import React from 'react'
import createReactClass from 'create-react-class'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classNames from 'classnames'

import { withGettext } from 'lib/gettext'
import { hasAnyRole, Role } from 'auth'
import { AuthorizedFragment } from 'common'

import { SchemaBranchMixin } from 'legacy/libs/baobab-react-mixins'
import { FormComponentMixin } from 'legacy/libs/react-form-tools'
import BaobabPropTypes from 'legacy/libs/baobab-prop-types'

import TagSelectTree from '../tag-select-tree'
import TagMixin from '../mixins/tag'
import AddTagButton from '../add-tag-button'

import s from './tag-select.module.scss'

const TagSelect = createReactClass({
  mixins: [SchemaBranchMixin, FormComponentMixin, TagMixin],

  propTypes: {
    gettext: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    service: PropTypes.func.isRequired,
    createService: PropTypes.func,
    deleteService: PropTypes.func,
    approveService: PropTypes.func,
    refuseService: PropTypes.func,
    tree: PropTypes.oneOfType([BaobabPropTypes.baobab, BaobabPropTypes.cursor]),
    entryTagGroupName: PropTypes.string,
  },

  schema: {
    childrenCount: 0,
    childrenTags: {},
    name: null,
    pk: null,
    opened: false,
    approved: false,
    entryTagGroup: null,
    parentTag: null,
  },

  cursors(props, context) {
    return {
      selectedTags: this.getCursor(props, context),
    }
  },

  getDefaultProps() {
    return {
      onChange: _.identity,
    }
  },

  componentDidUpdate(prevProps, prevState) {
    const { pk } = this.state
    const prevTag = _.find(prevState.selectedTags, { pk })
    const currentTag = _.find(this.state.selectedTags, { pk })

    if (prevTag && currentTag && prevTag.approved !== currentTag.approved) {
      this.cursors.approved.set(true)
    }

    if (prevTag && !prevTag.approved && !currentTag) {
      this.onSuccessDelete()
    }
  },

  onSuccessDelete() {
    const parentTagCursor = this.getParentTagTree(this.props.tree)
    if (parentTagCursor) {
      parentTagCursor.apply('childrenCount', (x) => x - 1)
    }

    this.props.tree.unset()
  },

  unsetSelectedTags() {
    const selectedTagCursor = this.cursors.selectedTags.select({
      pk: this.state.pk,
    })

    if (selectedTagCursor.exists()) {
      selectedTagCursor.unset()
      this.setDirtyState()
    }
  },

  deleteTag() {
    this.props.deleteService(this.state.pk).then(() => {
      this.unsetSelectedTags()
      this.onSuccessDelete()
    })
  },

  onApproveClick() {
    this.props.approveService(this.state.pk).then(() => {
      this.cursors.approved.set(true)

      const selectedTagCursor = this.cursors.selectedTags.select({
        pk: this.state.pk,
      })
      selectedTagCursor.select('approved').set(true)
    })
  },

  onRejectClick() {
    this.props.refuseService(this.state.pk).then(() => {
      this.unsetSelectedTags()
      this.onSuccessDelete()
    })
  },

  onTitleClick() {
    this.cursors.opened.apply((x) => !x)
  },

  onCancelClick() {
    this.props.onChange(this.props.tree)
    this.deleteTag()
  },

  renderTitle() {
    const pending = !this.state.approved

    const className = classNames(s.item, {
      [s._opened]: this.state.opened,
      [s._pending]: pending,
    })

    return (
      <div className={s.wrapper}>
        <span className={className} onClick={this.onTitleClick}>
          <span className={s.title}>{this.state.name}</span>
        </span>
        {pending ? (
          <span className="mr-3 text-gray-500">
            {this.props.gettext('Pending...')}
          </span>
        ) : null}
        <AddTagButton
          tree={this.props.tree}
          selectedTags={this.cursors.selectedTags}
        />
      </div>
    )
  },

  render() {
    const { gettext } = this.props

    if (!this.state.name) {
      return null
    }

    return (
      <div className={s.tag}>
        {this.renderTitle()}

        {this.state.opened && (
          <div>
            <TagSelectTree
              tree={this.props.tree}
              cursor={this.cursors.selectedTags}
              entryTagGroupName={this.props.entryTagGroupName}
              {..._.pick(this.props, [
                'onChange',
                'service',
                'deleteService',
                'createService',
                'approveService',
                'refuseService',
              ])}
            />
          </div>
        )}

        {!this.state.approved && (
          <AuthorizedFragment
            authorize={(user) =>
              hasAnyRole(user, [Role.REGIONAL_EDITOR, Role.MANAGING_EDITOR])
            }
          >
            <div className={s.approve}>
              <div className={s.approve__btn} onClick={this.onApproveClick}>
                {gettext('Accept')}
              </div>
              <div className={s.reject__btn} onClick={this.onRejectClick}>
                {gettext('Reject')}
              </div>
            </div>
          </AuthorizedFragment>
        )}
      </div>
    )
  },
})

export default withGettext(TagSelect)
